import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../../components/icon';
var IconEmail = React.forwardRef(function (props, ref) {
  return React.createElement(Icon, _extends({}, props, {
    content: {
      "16": {
        "height": 16,
        "width": 16,
        "source": "<path d=\"M16 8a8 8 0 1 0-4.44 7.17 1 1 0 0 0 .44-1.34 1 1 0 0 0-1.34-.45A6 6 0 1 1 14 8a2.05 2.05 0 0 1-.79 1.91 1.15 1.15 0 0 1-1.12.06.75.75 0 0 1-.37-.71v-4a1 1 0 0 0-1-1 1 1 0 0 0-.59.21A4.17 4.17 0 0 0 8 3.89a4.11 4.11 0 1 0 2.5 7.37 2.55 2.55 0 0 0 .6.47 3 3 0 0 0 1.47.38 3.27 3.27 0 0 0 1.67-.47A4 4 0 0 0 16 8zm-8 2.11a2.11 2.11 0 0 1 0-4.22 2.07 2.07 0 0 1 1.72.91v2.4a2.07 2.07 0 0 1-1.72.91z\"></path>"
      },
      "24": {
        "height": 24,
        "width": 24,
        "source": "<path d=\"M23 12a11 11 0 1 0-11 11 10.88 10.88 0 0 0 4.89-1.14 1 1 0 0 0-.89-1.8 8.78 8.78 0 0 1-4 .94 9 9 0 1 1 9-9 3.32 3.32 0 0 1-1.34 3.1 2.07 2.07 0 0 1-2 .09 1.49 1.49 0 0 1-.73-1.38v-5.7a1 1 0 0 0-1-1 1 1 0 0 0-.8.43 5.38 5.38 0 0 0-3.09-1 5.44 5.44 0 1 0 3.62 9.5 3.25 3.25 0 0 0 1 .89 3.85 3.85 0 0 0 1.89.48 4.19 4.19 0 0 0 2.16-.6A5.24 5.24 0 0 0 23 12zm-11 3.44a3.44 3.44 0 1 1 2.89-5.31v3.74A3.43 3.43 0 0 1 12 15.44z\"></path>"
      }
    },
    ref: ref
  }));
});
IconEmail.displayName = 'IconEmail';
IconEmail.defaultProps = {
  size: 16
};
export default IconEmail;